import React from 'react'
import { dateConvert, RenderSignatureField } from '../../utils/Helper'
import { useJoiningReport } from '../../Hooks/Features/WelcomeKit/useJoiningReport'
import { useCommanKit } from '../../Hooks/Features/WelcomeKit/useCommanKit'

const JoiningReport = ({ data, onPrev, onNext, readOnly }) => {
    const { checkedIds, handleCheckboxChange, documents, handleSubmit } = useJoiningReport({ data, onNext });
    const { signature, handleChange, handleRemove } = useCommanKit({ data });

    return (
        <div className='my-2'>
            <h4 style={{ backgroundColor: '#f2f2f2', padding: '0.5rem 1rem' }}>Joining Report</h4>
            <section className="py-2" aria-label="Joining letter introduction">
                <p>To,</p>
                <strong>The HR Department,</strong>
                <p className="my-2">
                    SRKAY Consulting Group Pvt. Ltd.<br />
                    {data?.commonDetails?.job_location}
                </p>
                <p>
                    This is with reference to your offer letter dated offering me the post of{' '}
                    <strong>{data?.employee?.role_on_project}</strong> in Band 3 Level 2 of your Organization.
                    <br />
                    I hereby report to duty on this{' '}
                    <strong>{dateConvert(data?.employee?.joining_date, 'day-mon-year')}</strong>.
                </p>
                <p className="my-2">
                    I am submitting herewith my following documents, certificates and details.
                </p>
            </section>
            <section className="px-4" aria-label="List of submitted documents">
                <ol style={{ padding: 0 }}>
                    {documents?.map((doc, index) => (
                        <li key={doc.value} className="mb-2">
                            <label className='c-pointer d-flex '>
                                <input
                                    type="checkbox"
                                    checked={checkedIds.includes(doc.value)}
                                    onChange={() => handleCheckboxChange(doc.value)}
                                    className="mx-1"
                                    aria-label={`Checkbox for ${doc.label}`}
                                />
                                <strong>{doc.label}</strong>
                            </label>
                        </li>
                    ))}
                </ol>
            </section>
            <section>
                <p>
                    Place of posting: <strong>{data?.commonDetails?.job_location}</strong>
                </p>
                <p className="my-2">
                    I request you to kindly accept the above mentioned forms and complete my joining
                    formalities.
                </p>
                <p>Thanking you,</p>

                <p className="mt-3">Employee Signature</p>
                <div>
                    {!readOnly && <RenderSignatureField
                        name="user_signature_url"
                        handleChange={handleChange}
                        value={signature}
                        handleRemove={handleRemove}
                    />}
                    <div className="my-2">
                        <p>Employee Name</p>
                        <strong>{data?.employee?.user_display_name}</strong>
                    </div>
                </div>

                <div className="border-top py-2">
                    <strong>(For Company Purpose)</strong>
                    <div className="d-flex justify-content-between">
                        <span>
                            Employee Id: <strong>{data?.employee?.employee_id}</strong>
                        </span>
                        <span>
                            UAN No: <strong>{data.commonDetails?.uan_number}</strong>
                        </span>
                        <span>
                            Business Unit: <strong>{data?.employee?.business_unit}</strong>
                        </span>
                    </div>
                </div>
            </section>
            {
                !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
                    <button className="btn-default" type="button" onClick={onPrev}>Previous</button>
                    <button className="btn-primary" type="button" onClick={handleSubmit}>Save & Next</button>
                </div>
            }
        </div>
    );
};

export default JoiningReport;
